export default __webpack_public_path__ + "static/media/EmployerLogo.6a14214c.svg";